module.exports = __webpack_public_path__ + "static/media/kevinHart.963811b9.png";